import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { InternalFieldName } from 'react-hook-form/dist/types/fields';
import Form from '../Crud/Form';
import CustomButton from '../CustomButton/CustomButton';
import ColorPicker from '../ColorPicker/ColorPicker';

export interface TagFormFields {
  name: string;
  color?: string;
}

interface TagFormProps {
  isLoading: boolean;
  title: string;
  formFields: TagFormFields;
  formErrors: Record<string, any>;
  onSubmit: (data: any) => void;
}

function addServerErrors<T>(
  errors: { [P in keyof T]?: string[] },
  setError: any
) {
  return Object.keys(errors).forEach((key) => {
    setError(key as keyof T, {
      type: 'server',
      message: errors[key as keyof T]!.join('. '),
    });
  });
}

export default function TagForm({
  isLoading,
  title,
  formFields,
  formErrors,
  onSubmit,
}: TagFormProps) {
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
    reset,
    setValue,
  } = useForm<TagFormFields>();
  const [colorSelected, setColorSelected] = useState<string | undefined>('');

  useEffect(() => {
    reset(formFields);
    setColorSelected(formFields?.color);
  }, [formFields]);

  useEffect(() => {
    setValue('color', colorSelected);
  }, [colorSelected]);

  useEffect(() => {
    let shouldFocus = true;
    Object.keys(formErrors || {}).forEach((field: InternalFieldName) => {
      addServerErrors(formErrors, setError);

      shouldFocus = false;
    });
  }, [formErrors]);

  return (
    <Form isLoading={isLoading} title={title} onSubmitCallback={() => {}}>
      <form>
        <div className='mt-2 mb-3'>
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label htmlFor='inputLabel' className='form-label'>
            Título
          </label>
          <input
            {...register('name', { required: true })}
            className='form-control'
            id='inputLabel'
            placeholder='Título'
            type='text'
            required
          />
          {errors.name && (
            <div id='emailHelp' className='form-text text-danger'>
              {errors.name.message}
            </div>
          )}
        </div>
        <div className='mt-2 mb-3'>
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label htmlFor='inputLabel' className='form-label'>
            Cor
          </label>
          <ColorPicker
            colorSelected={colorSelected}
            setColorSelected={setColorSelected}
          />
          {errors.color && (
            <div id='emailHelp' className='form-text text-danger'>
              {errors.color.message}
            </div>
          )}
        </div>
        <div className='d-flex justify-content-end gap-2'>
          <Link to='/tags' className='btn btn-secondary'>
            Cancelar
          </Link>
          <CustomButton
            type='button'
            className='btn btn-primary'
            handleClick={handleSubmit(onSubmit)}
          >
            Salvar
          </CustomButton>
        </div>
      </form>
    </Form>
  );
}
